import { config } from '../../config';

export default ['staging', 'production'].includes(config.FEEDBACK_ENV);
